import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-action-loader',
  template: `
    <div class="action-loader-wrapper" [ngClass]="{ 'wrapper-100': wrapperFullWidth }">
      <ng-content></ng-content>
      <mat-progress-bar
        *ngIf="isRunning" 
        [ngClass]="{
          'button-progress-bar-hidden': !isRunning,
          'button-progress-bar-visible': isRunning
        }"
        mode="buffer"
        class="m-t-5 progress-bar-absolute"
      ></mat-progress-bar>
    </div>
  `,
  styles: ['.action-loader-wrapper { width: fit-content; position: relative; }', '.wrapper-100 { width: 100% !important; }', '.progress-bar-absolute { position: absolute; top: 90%; left: 0; }'],
})
export class ActionLoaderComponent {
  @Input()
  wrapperFullWidth = false;

  isRunning = false;

  constructor() {}

  public start() {
    this.isRunning = true;
  }

  public stop() {
    this.isRunning = false;
  }
}
